import Layout from '@/View/systemSetting/layOut/Layout.vue'
export const systemSetting = {
  // systemSetting dashboard Start
  path: '/systemsettings',
  component: Layout,
  hidden: false,
  redirect: '/systemsetting/dashboard',
  name: 'systemSettings',
  meta: {
    breadCrumb: 'systemSettings',
    title: 'dashboards',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [{
    path: '/systemsetting/dashboard',
    component: () => import('@/View/systemSetting/dashboard/dashboard.vue'),
    name: 'systemSettingsDashboard',
    meta: {
      breadCrumb: 'Dashboard',
      icon: 'dashboard',
      title: 'Dashboard',
      selected: false,
      permissionList: []
    }
  },
  { // User Object Start
    path: '/systemsetting/role',
    component: () => import('@/View/systemSetting/Main/mainView.vue'),
    hidden: false,
    redirect: '/systemsetting/role/roleManagementlist',
    name: 'RoleManagementlist',
    meta: {
      breadCrumb: 'role',
      title: 'Role Management',
      selected: false,
      permissionList: []
    },
    children: [{
      path: '/systemsetting/dashboard',
      component: () => import('@/View/systemSetting/dashboard/dashboard.vue'),
      name: 'systemSettings',
      hidden: false,
      meta: {
        breadCrumb: 'Dashboard',
        title: 'Dashboard'
      }
    },
    {
      path: '/systemsetting/role/roleManagementlist',
      component: () => import('@/View/systemSetting/RoleManagement/roleManagementlist.vue'),
      name: 'RoleManagementlist',
      hidden: false,
      meta: {
        breadCrumb: 'RoleManagement',
        icon: '',
        title: 'List',
        selected: false,
        permissionList: []
      }
    },
    {
      path: '/systemsetting/role/:roleId',
      component: () => import('@/View/systemSetting/RoleManagement/addNewrole.vue'),
      name: 'AddRole',
      meta: {
        breadCrumb: 'add',
        icon: '',
        title: 'Manage Role',
        selected: false,
        permissionList: []
      }
    }
    ]
  },
  { // User Company Object Start
    path: '/systemSetting/Company',
    component: () => import('@/View/systemSetting/Main/mainView.vue'),
    hidden: false,
    redirect: '/systemSetting/Company/companyList.vue',
    name: 'companyList',
    meta: {
      breadCrumb: 'Company',
      title: 'Company',
      selected: false,
      permissionList: []
    },
    children: [{
      path: '/systemSetting/Company/companyList',
      component: () => import('@/View/systemSetting/Company/companyList.vue'),
      name: 'companyList',
      meta: {
        breadCrumb: 'Company',
        icon: '',
        title: 'Company Settings',
        selected: false,
        permissionList: []
      }
    }
    // {
    //   path: '/systemSetting/Company/companydetails',
    //   component: () => import('@/View/systemSetting/Company/companydetails.vue'),
    //   name: 'companydetails',
    //   meta: {
    //     breadCrumb: 'Details',
    //     icon: '',
    //     title: 'Company Details',
    //     selected: false,
    //     permissionList: []
    //   }
    // }
    ]
  }]
}



// WEBPACK FOOTER //
// ./src/View/systemSetting/routers/index.js